import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../components/common/SafeIcon';
import Navbar from '../../components/nav/Navbar';
import TransactionManager from '../../components/admin/TransactionManager';
import CreatorApprovalTable from '../../components/admin/CreatorApprovalTable';
import PlatformAdminApprovalTable from '../../components/admin/PlatformAdminApprovalTable';
import PlatformAdminOverview from '../../components/admin/PlatformAdminOverview';
import PlatformAdminUsersTable from '../../components/admin/PlatformAdminUsersTable';
import PlatformAdminContentTable from '../../components/admin/PlatformAdminContentTable';
import PlatformAdminAuditLog from '../../components/admin/PlatformAdminAuditLog';
import { useAuth } from '../../context/AuthContext';

const {
  FiUsers, FiMusic, FiDollarSign, FiActivity, FiShield,
  FiUserPlus, FiList,
} = FiIcons;

const TABS = [
  { id: 'overview',         label: 'Overview',     icon: FiActivity   },
  { id: 'users',            label: 'Users',        icon: FiUsers      },
  { id: 'content',          label: 'Content',      icon: FiMusic      },
  { id: 'transactions',     label: 'Transactions', icon: FiDollarSign },
  { id: 'creator_requests', label: 'Creator Apps', icon: FiUserPlus   },
  { id: 'admin_requests',   label: 'Admin Apps',   icon: FiShield     },
  { id: 'audit',            label: 'Audit Log',    icon: FiList       },
];

export default function PlatformAdminDashboard() {
  const { profile } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  console.log('[Dashboard] Render:', { activeTab, profileRole: profile?.role });

  return (
    <div className="min-h-screen bg-neutral-900 text-white">
      <Navbar />
      
      {/* Main container with proper spacing for fixed navbar */}
      <div className="pt-20 flex h-[calc(100vh-80px)]">
        {/* Sidebar */}
        <aside className="w-64 flex-shrink-0">
          <div className="sticky top-20 h-[calc(100vh-100px)] bg-black border-r border-neutral-800 overflow-y-auto">
            <div className="p-4">
              <h2 className="text-xs font-bold text-neutral-500 uppercase tracking-wider mb-4 px-3">
                Platform Admin
              </h2>
              
              <nav className="space-y-1">
                {TABS.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                      activeTab === tab.id
                        ? 'bg-indigo-600/10 text-indigo-400 border border-indigo-500/20'
                        : 'text-neutral-400 hover:bg-neutral-800/50 hover:text-white border border-transparent'
                    }`}
                  >
                    <SafeIcon icon={tab.icon} className="text-lg flex-shrink-0" />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>

              {/* Divider and help text */}
              <div className="mt-6 pt-4 border-t border-neutral-800 px-3">
                <p className="text-xs text-neutral-500">
                  Manage platform settings, users, and content
                </p>
              </div>
            </div>
          </div>
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 overflow-auto">
          <div className="p-8 max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-8 pb-6 border-b border-neutral-800">
              <h1 className="text-2xl font-bold flex items-center gap-3">
                <SafeIcon icon={TABS.find((t) => t.id === activeTab)?.icon || FiActivity} className="text-indigo-400" />
                {TABS.find((t) => t.id === activeTab)?.label}
              </h1>
              <p className="text-neutral-400 text-sm mt-2">
                {activeTab === 'overview' && 'Platform-wide metrics and insights'}
                {activeTab === 'users' && 'Manage user accounts and permissions'}
                {activeTab === 'content' && 'View and moderate platform content'}
                {activeTab === 'transactions' && 'Monitor revenue and payouts'}
                {activeTab === 'creator_requests' && 'Review creator applications'}
                {activeTab === 'admin_requests' && 'Review platform admin applications'}
                {activeTab === 'audit' && 'System activity and admin actions log'}
              </p>
            </div>
            
            {/* Content */}
            <div className="animate-fade-in">
              {activeTab === 'overview' && <PlatformAdminOverview />}
              {activeTab === 'users' && <PlatformAdminUsersTable />}
              {activeTab === 'content' && <PlatformAdminContentTable />}
              {activeTab === 'transactions' && <TransactionManager />}
              {activeTab === 'creator_requests' && <CreatorApprovalTable />}
              {activeTab === 'admin_requests' && <PlatformAdminApprovalTable />}
              {activeTab === 'audit' && <PlatformAdminAuditLog />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}